import { CommonModule } from '@angular/common';
import { Component,  Input, OnInit, ViewChild, ElementRef, Output, EventEmitter, NgZone } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@Component({
    selector: 'mutating-input',
    template: `
<div class="holder">
  <mat-form-field class="general">
    <input matInput
      #input 
      *ngIf="!isArea" 
      [disabled]="disabled" 
      [name]="name" 
      [(ngModel)]="object[prop]" 
      [placeholder]="placeholder"
      (keyup)="sendText($event)" 
      (focusout)="unfocus.emit()"
    >
    <textarea matInput
      *ngIf="isArea"
      cdkTextareaAutosize
      cdkAutosizeMaxRows="100"
      [cdkAutosizeMinRows]="areaMinRows"
      [name]="name"
      [disabled]="disabled"
      (keyup)="sendText($event)"
      (focusout)="unfocus.emit()"
      [(ngModel)]="object[prop]"
      [placeholder]="placeholder"
    ></textarea>
  </mat-form-field>
  <div *ngIf="hint" class="hint">{{ hint }}</div>
  <div *ngIf="!!error" class="error">{{ error }}</div>
</div>
`,
    styles: [`
  .general { display: flex; align-items: center; }
  .holder { display: flex; flex-direction: column; padding-bottom: 5px; }
  .hint { font-size: 12px; color: rgba(0,0,0,0.4); margin: -15px 0 15px 0; font-style: italic; }
  .mat-form-field.general textarea.mat-input-element { overflow: hidden; }
  .error { color: #f05454; font-size: 11px; margin-top: -15px; margin-bottom: 10px; }


`],
    imports: [MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, CommonModule],
    standalone: true,
})

// This mutates the object in place, and also adds the prop as an empty text field if it doesn't already exist
export class MutatingInputComponent<T> implements OnInit {
  @Input() placeholder = ''
  @Input() name = ''
  @Input() object: T
  @Input() disabled
  @Input() prop: keyof T
  @Input() hint
  @Input() error = ''
  @Input() focus
  @Input() isArea = false
  @Input() areaMinRows = 1
  @Output() textChange: EventEmitter<string> = new EventEmitter()
  @Output() unfocus: EventEmitter<void> = new EventEmitter()

  @ViewChild('input') input: ElementRef;
  constructor(private _ngZone: NgZone) {}

  sendText(event) {
    this.textChange.emit(event.target.value)
  }

  ngOnInit() {
    this.focus && setTimeout(() => {
      this.input.nativeElement.focus()
    },0)
  }
}
